export default function (str) {
    if (!str) {
        return '';
    }

    return str.toString().replace(',', '.');
}
